import { Subject } from 'rxjs';

class Bus {
    recycleWasteCmd$ = new Subject();

    stockClickEvent$ = new Subject();
}

export const bus = new Bus();
